<script lang="ts">
  import { onMount } from 'svelte';
  import type { ArenaMap } from '@arena/shared';
  import Editor from './components/Editor.svelte';
  import GameView from './components/GameView.svelte';
  import Line from './components/Line.svelte';
  import Viewer from './components/Viewer.svelte';
  import Welcome from './components/Welcome.svelte';
  import { hasSession } from './lib/auth';
  import { app, connect } from './lib/net.svelte';

  let route = $state(location.hash);
  let failure = $state<string | null>(null);
  let welcome = $state(false);
  let hubMap = $state<ArenaMap | null>(null);

  /** Why this device can't play, shown in place of the game. */
  const unplayable = !matchMedia('(any-pointer: fine)').matches
    ? 'Sandsworn is played with a keyboard and mouse. Open sandsworn.gg on a computer to play.'
    : !document.createElement('canvas').getContext('webgl2')
      ? 'Sandsworn needs WebGL 2, which this browser has turned off or does not support. Try an up-to-date Chrome, Firefox, Edge or Safari, and check that hardware acceleration is on.'
      : null;

  const fail = (e: unknown) =>
    (failure = e instanceof Error ? e.message : String(e));

  onMount(() => {
    const onHash = () => (route = location.hash);
    window.addEventListener('hashchange', onHash);
    const stop = () => window.removeEventListener('hashchange', onHash);
    if (unplayable) return stop;
    hasSession()
      .then((signedIn) => (signedIn ? connect() : (welcome = true)))
      .catch(fail);
    fetch('/hub.json')
      .then((r) => r.json())
      .then((map: ArenaMap) => (hubMap = map))
      .catch(fail);
    return stop;
  });
</script>

{#if route.startsWith('#/editor')}
  <Editor />
{:else if route.startsWith('#/viewer')}
  <Viewer />
{:else if unplayable}
  <div class="center panel notice">
    <img class="wordmark" src="/wordmark/stacked.webp" alt="Sandsworn" />
    <p>{unplayable}</p>
  </div>
{:else if failure}
  <div class="center panel">
    <h2>Could not connect</h2>
    <p>{failure}</p>
    <button onclick={() => location.reload()}>Retry</button>
  </div>
{:else if welcome}
  <Welcome onenter={() => ((welcome = false), connect())} />
{:else if app.match}
  {#key app.match.matchId}
    <GameView match={app.match} />
  {/key}
{:else if app.line}
  <Line />
{:else if app.user && hubMap}
  {#key app.user.id}
    <GameView
      match={{
        matchId: 'hub',
        bracket: 'hub',
        map: hubMap,
        youId: app.user.id,
      }}
    />
  {/key}
{:else}
  <div class="center loading">Connecting…</div>
{/if}

<style>
  .center {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .notice {
    width: min(420px, 85vw);
  }
  .wordmark {
    width: min(240px, 60vw);
  }
  .loading {
    font-size: 24px;
    color: var(--gold);
  }
</style>
